import i18n from '../locales/index';
/**
 * @description 手機區號
 */
export default [
  {
    code: 1,
    text: i18n.t('upgrade_page_layout_header_31')
  },
  {
    code: 44,
    text: i18n.t('utils_areas_code_825')
  },
  {
    code: 33,
    text: i18n.t('utils_areas_code_894')
  },
  {
    code: 886,
    text: i18n.t('utils_areas_code_817')
  },
  {
    code: 852,
    text: i18n.t('utils_areas_code_818')
  },
  {
    code: 853,
    text: i18n.t('utils_areas_code_819')
  },
  {
    code: 62,
    text: i18n.t('utils_areas_code_820')
  },
  {
    code: 60,
    text: i18n.t('utils_areas_code_821')
  },
  {
    code: 65,
    text: i18n.t('utils_areas_code_822')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_823')
  },
  {
    code: 86,
    text: i18n.t('utils_areas_code_824')
  },
  {
    code: 93,
    text: i18n.t('utils_areas_code_826')
  },
  {
    code: 355,
    text: i18n.t('utils_areas_code_827')
  },
  {
    code: 213,
    text: i18n.t('utils_areas_code_828')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_829')
  },
  {
    code: 376,
    text: i18n.t('utils_areas_code_830')
  },
  {
    code: 244,
    text: i18n.t('utils_areas_code_831')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_832')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_833')
  },
  {
    code: 54,
    text: i18n.t('utils_areas_code_834')
  },
  {
    code: 374,
    text: i18n.t('utils_areas_code_835')
  },
  {
    code: 297,
    text: i18n.t('utils_areas_code_836')
  },
  {
    code: 61,
    text: i18n.t('utils_areas_code_837')
  },
  {
    code: 43,
    text: i18n.t('utils_areas_code_838')
  },
  {
    code: 994,
    text: i18n.t('utils_areas_code_839')
  },
  {
    code: 973,
    text: i18n.t('utils_areas_code_840')
  },
  {
    code: 880,
    text: i18n.t('utils_areas_code_841')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_842')
  },
  {
    code: 375,
    text: i18n.t('utils_areas_code_843')
  },
  {
    code: 32,
    text: i18n.t('utils_areas_code_844')
  },
  {
    code: 501,
    text: i18n.t('utils_areas_code_845')
  },
  {
    code: 229,
    text: i18n.t('utils_areas_code_846')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_847')
  },
  {
    code: 975,
    text: i18n.t('utils_areas_code_848')
  },
  {
    code: 591,
    text: i18n.t('utils_areas_code_849')
  },
  {
    code: 599,
    text: i18n.t('utils_areas_code_850')
  },
  {
    code: 387,
    text: i18n.t('utils_areas_code_851')
  },
  {
    code: 267,
    text: i18n.t('utils_areas_code_852')
  },
  {
    code: 55,
    text: i18n.t('utils_areas_code_853')
  },
  {
    code: 246,
    text: i18n.t('utils_areas_code_854')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_855')
  },
  {
    code: 673,
    text: i18n.t('utils_areas_code_856')
  },
  {
    code: 359,
    text: i18n.t('utils_areas_code_857')
  },
  {
    code: 226,
    text: i18n.t('utils_areas_code_858')
  },
  {
    code: 257,
    text: i18n.t('utils_areas_code_859')
  },
  {
    code: 855,
    text: i18n.t('utils_areas_code_860')
  },
  {
    code: 237,
    text: i18n.t('utils_areas_code_861')
  },
  {
    code: 238,
    text: i18n.t('utils_areas_code_862')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_863')
  },
  {
    code: 225,
    text: i18n.t('utils_areas_code_864')
  },
  {
    code: 236,
    text: i18n.t('utils_areas_code_865')
  },
  {
    code: 235,
    text: i18n.t('utils_areas_code_866')
  },
  {
    code: 56,
    text: i18n.t('utils_areas_code_867')
  },
  {
    code: 57,
    text: i18n.t('utils_areas_code_868')
  },
  {
    code: 269,
    text: i18n.t('utils_areas_code_869')
  },
  {
    code: 682,
    text: i18n.t('utils_areas_code_870')
  },
  {
    code: 506,
    text: i18n.t('utils_areas_code_871')
  },
  {
    code: 385,
    text: i18n.t('utils_areas_code_872')
  },
  {
    code: 53,
    text: i18n.t('utils_areas_code_873')
  },
  {
    code: 599,
    text: i18n.t('utils_areas_code_874')
  },
  {
    code: 357,
    text: i18n.t('utils_areas_code_875')
  },
  {
    code: 420,
    text: i18n.t('utils_areas_code_876')
  },
  {
    code: 243,
    text: i18n.t('utils_areas_code_877')
  },
  {
    code: 45,
    text: i18n.t('utils_areas_code_878')
  },
  {
    code: 253,
    text: i18n.t('utils_areas_code_879')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_880')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_881')
  },
  {
    code: 593,
    text: i18n.t('utils_areas_code_882')
  },
  {
    code: 20,
    text: i18n.t('utils_areas_code_883')
  },
  {
    code: 503,
    text: i18n.t('utils_areas_code_884')
  },
  {
    code: 240,
    text: i18n.t('utils_areas_code_885')
  },
  {
    code: 291,
    text: i18n.t('utils_areas_code_886')
  },
  {
    code: 372,
    text: i18n.t('utils_areas_code_887')
  },
  {
    code: 251,
    text: i18n.t('utils_areas_code_888')
  },
  {
    code: 500,
    text: i18n.t('utils_areas_code_889')
  },
  {
    code: 298,
    text: i18n.t('utils_areas_code_890')
  },
  {
    code: 691,
    text: i18n.t('utils_areas_code_891')
  },
  {
    code: 679,
    text: i18n.t('utils_areas_code_892')
  },
  {
    code: 358,
    text: i18n.t('utils_areas_code_893')
  },
  {
    code: 594,
    text: i18n.t('utils_areas_code_895')
  },
  {
    code: 689,
    text: i18n.t('utils_areas_code_896')
  },
  {
    code: 241,
    text: i18n.t('utils_areas_code_897')
  },
  {
    code: 995,
    text: i18n.t('utils_areas_code_898')
  },
  {
    code: 49,
    text: i18n.t('utils_areas_code_899')
  },
  {
    code: 233,
    text: i18n.t('utils_areas_code_900')
  },
  {
    code: 350,
    text: i18n.t('utils_areas_code_901')
  },
  {
    code: 30,
    text: i18n.t('utils_areas_code_902')
  },
  {
    code: 299,
    text: i18n.t('utils_areas_code_903')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_904')
  },
  {
    code: 590,
    text: i18n.t('utils_areas_code_905')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_906')
  },
  {
    code: 502,
    text: i18n.t('utils_areas_code_907')
  },
  {
    code: 44,
    text: i18n.t('utils_areas_code_908')
  },
  {
    code: 224,
    text: i18n.t('utils_areas_code_909')
  },
  {
    code: 245,
    text: i18n.t('utils_areas_code_910')
  },
  {
    code: 592,
    text: i18n.t('utils_areas_code_911')
  },
  {
    code: 509,
    text: i18n.t('utils_areas_code_912')
  },
  {
    code: 504,
    text: i18n.t('utils_areas_code_913')
  },
  {
    code: 36,
    text: i18n.t('utils_areas_code_914')
  },
  {
    code: 354,
    text: i18n.t('utils_areas_code_915')
  },
  {
    code: 91,
    text: i18n.t('utils_areas_code_916')
  },
  {
    code: 98,
    text: i18n.t('utils_areas_code_917')
  },
  {
    code: 964,
    text: i18n.t('utils_areas_code_918')
  },
  {
    code: 353,
    text: i18n.t('utils_areas_code_919')
  },
  {
    code: 44,
    text: i18n.t('utils_areas_code_920')
  },
  {
    code: 972,
    text: i18n.t('utils_areas_code_921')
  },
  {
    code: 39,
    text: i18n.t('utils_areas_code_922')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_923')
  },
  {
    code: 81,
    text: i18n.t('upgrade_page_layout_header_30')
  },
  {
    code: 44,
    text: i18n.t('utils_areas_code_924')
  },
  {
    code: 962,
    text: i18n.t('utils_areas_code_925')
  },
  {
    code: 7,
    text: i18n.t('utils_areas_code_926')
  },
  {
    code: 254,
    text: i18n.t('utils_areas_code_927')
  },
  {
    code: 686,
    text: i18n.t('utils_areas_code_928')
  },
  {
    code: 383,
    text: i18n.t('utils_areas_code_929')
  },
  {
    code: 965,
    text: i18n.t('utils_areas_code_930')
  },
  {
    code: 996,
    text: i18n.t('utils_areas_code_931')
  },
  {
    code: 856,
    text: i18n.t('utils_areas_code_932')
  },
  {
    code: 371,
    text: i18n.t('utils_areas_code_933')
  },
  {
    code: 961,
    text: i18n.t('utils_areas_code_934')
  },
  {
    code: 266,
    text: i18n.t('utils_areas_code_935')
  },
  {
    code: 231,
    text: i18n.t('utils_areas_code_936')
  },
  {
    code: 218,
    text: i18n.t('utils_areas_code_937')
  },
  {
    code: 423,
    text: i18n.t('utils_areas_code_938')
  },
  {
    code: 370,
    text: i18n.t('utils_areas_code_939')
  },
  {
    code: 352,
    text: i18n.t('utils_areas_code_940')
  },
  {
    code: 389,
    text: i18n.t('utils_areas_code_941')
  },
  {
    code: 261,
    text: i18n.t('utils_areas_code_942')
  },
  {
    code: 265,
    text: i18n.t('utils_areas_code_943')
  },
  {
    code: 960,
    text: i18n.t('utils_areas_code_944')
  },
  {
    code: 223,
    text: i18n.t('utils_areas_code_945')
  },
  {
    code: 356,
    text: i18n.t('utils_areas_code_946')
  },
  {
    code: 692,
    text: i18n.t('utils_areas_code_947')
  },
  {
    code: 596,
    text: i18n.t('utils_areas_code_948')
  },
  {
    code: 222,
    text: i18n.t('utils_areas_code_949')
  },
  {
    code: 230,
    text: i18n.t('utils_areas_code_950')
  },
  {
    code: 262,
    text: i18n.t('utils_areas_code_951')
  },
  {
    code: 52,
    text: i18n.t('utils_areas_code_952')
  },
  {
    code: 373,
    text: i18n.t('utils_areas_code_953')
  },
  {
    code: 377,
    text: i18n.t('utils_areas_code_954')
  },
  {
    code: 976,
    text: i18n.t('utils_areas_code_955')
  },
  {
    code: 382,
    text: i18n.t('utils_areas_code_956')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_957')
  },
  {
    code: 212,
    text: i18n.t('utils_areas_code_958')
  },
  {
    code: 258,
    text: i18n.t('utils_areas_code_959')
  },
  {
    code: 95,
    text: i18n.t('utils_areas_code_960')
  },
  {
    code: 264,
    text: i18n.t('utils_areas_code_961')
  },
  {
    code: 674,
    text: i18n.t('utils_areas_code_962')
  },
  {
    code: 977,
    text: i18n.t('utils_areas_code_963')
  },
  {
    code: 31,
    text: i18n.t('utils_areas_code_964')
  },
  {
    code: 687,
    text: i18n.t('utils_areas_code_965')
  },
  {
    code: 64,
    text: i18n.t('utils_areas_code_966')
  },
  {
    code: 505,
    text: i18n.t('utils_areas_code_967')
  },
  {
    code: 227,
    text: i18n.t('utils_areas_code_968')
  },
  {
    code: 234,
    text: i18n.t('utils_areas_code_969')
  },
  {
    code: 683,
    text: i18n.t('utils_areas_code_970')
  },
  {
    code: 672,
    text: i18n.t('utils_areas_code_971')
  },
  {
    code: 850,
    text: i18n.t('utils_areas_code_972')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_973')
  },
  {
    code: 47,
    text: i18n.t('utils_areas_code_974')
  },
  {
    code: 968,
    text: i18n.t('utils_areas_code_975')
  },
  {
    code: 92,
    text: i18n.t('utils_areas_code_976')
  },
  {
    code: 680,
    text: i18n.t('utils_areas_code_977')
  },
  {
    code: 970,
    text: i18n.t('utils_areas_code_978')
  },
  {
    code: 507,
    text: i18n.t('utils_areas_code_979')
  },
  {
    code: 675,
    text: i18n.t('utils_areas_code_980')
  },
  {
    code: 595,
    text: i18n.t('utils_areas_code_981')
  },
  {
    code: 51,
    text: i18n.t('utils_areas_code_982')
  },
  {
    code: 63,
    text: i18n.t('utils_areas_code_983')
  },
  {
    code: 48,
    text: i18n.t('utils_areas_code_984')
  },
  {
    code: 351,
    text: i18n.t('utils_areas_code_985')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_986')
  },
  {
    code: 974,
    text: i18n.t('utils_areas_code_987')
  },
  {
    code: 262,
    text: i18n.t('utils_areas_code_988')
  },
  {
    code: 242,
    text: i18n.t('utils_areas_code_989')
  },
  {
    code: 40,
    text: i18n.t('utils_areas_code_990')
  },
  {
    code: 7,
    text: i18n.t('utils_areas_code_991')
  },
  {
    code: 250,
    text: i18n.t('utils_areas_code_992')
  },
  {
    code: 590,
    text: i18n.t('utils_areas_code_993')
  },
  {
    code: 290,
    text: i18n.t('utils_areas_code_994')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_995')
  },
  {
    code: 590,
    text: i18n.t('utils_areas_code_996')
  },
  {
    code: 508,
    text: i18n.t('utils_areas_code_997')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_998')
  },
  {
    code: 685,
    text: i18n.t('utils_areas_code_999')
  },
  {
    code: 378,
    text: i18n.t('utils_areas_code_1000')
  },
  {
    code: 239,
    text: i18n.t('utils_areas_code_1001')
  },
  {
    code: 966,
    text: i18n.t('utils_areas_code_1002')
  },
  {
    code: 221,
    text: i18n.t('utils_areas_code_1003')
  },
  {
    code: 381,
    text: i18n.t('utils_areas_code_1004')
  },
  {
    code: 248,
    text: i18n.t('utils_areas_code_1005')
  },
  {
    code: 232,
    text: i18n.t('utils_areas_code_1006')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_1007')
  },
  {
    code: 421,
    text: i18n.t('utils_areas_code_1008')
  },
  {
    code: 386,
    text: i18n.t('utils_areas_code_1009')
  },
  {
    code: 677,
    text: i18n.t('utils_areas_code_1010')
  },
  {
    code: 252,
    text: i18n.t('utils_areas_code_1011')
  },
  {
    code: 27,
    text: i18n.t('utils_areas_code_1012')
  },
  {
    code: 82,
    text: i18n.t('utils_areas_code_1013')
  },
  {
    code: 211,
    text: i18n.t('utils_areas_code_1014')
  },
  {
    code: 34,
    text: i18n.t('utils_areas_code_1015')
  },
  {
    code: 94,
    text: i18n.t('utils_areas_code_1016')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_1017')
  },
  {
    code: 249,
    text: i18n.t('utils_areas_code_1018')
  },
  {
    code: 597,
    text: i18n.t('utils_areas_code_1019')
  },
  {
    code: 268,
    text: i18n.t('utils_areas_code_1020')
  },
  {
    code: 46,
    text: i18n.t('utils_areas_code_1021')
  },
  {
    code: 41,
    text: i18n.t('utils_areas_code_1022')
  },
  {
    code: 963,
    text: i18n.t('utils_areas_code_1023')
  },
  {
    code: 992,
    text: i18n.t('utils_areas_code_1024')
  },
  {
    code: 255,
    text: i18n.t('utils_areas_code_1025')
  },
  {
    code: 66,
    text: i18n.t('utils_areas_code_1026')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_1027')
  },
  {
    code: 220,
    text: i18n.t('utils_areas_code_1028')
  },
  {
    code: 670,
    text: i18n.t('utils_areas_code_1029')
  },
  {
    code: 228,
    text: i18n.t('utils_areas_code_1030')
  },
  {
    code: 690,
    text: i18n.t('utils_areas_code_1031')
  },
  {
    code: 676,
    text: i18n.t('utils_areas_code_1032')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_1033')
  },
  {
    code: 216,
    text: i18n.t('utils_areas_code_1034')
  },
  {
    code: 90,
    text: i18n.t('utils_areas_code_1035')
  },
  {
    code: 993,
    text: i18n.t('utils_areas_code_1036')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_1037')
  },
  {
    code: 688,
    text: i18n.t('utils_areas_code_1038')
  },
  {
    code: 256,
    text: i18n.t('utils_areas_code_1039')
  },
  {
    code: 380,
    text: i18n.t('utils_areas_code_1040')
  },
  {
    code: 971,
    text: i18n.t('utils_areas_code_1041')
  },
  {
    code: 598,
    text: i18n.t('utils_areas_code_1042')
  },
  {
    code: 1,
    text: i18n.t('utils_areas_code_1043')
  },
  {
    code: 998,
    text: i18n.t('utils_areas_code_1044')
  },
  {
    code: 678,
    text: i18n.t('utils_areas_code_1045')
  },
  {
    code: 39,
    text: i18n.t('utils_areas_code_1046')
  },
  {
    code: 58,
    text: i18n.t('utils_areas_code_1047')
  },
  {
    code: 84,
    text: i18n.t('utils_areas_code_1048')
  },
  {
    code: 681,
    text: i18n.t('utils_areas_code_1049')
  },
  {
    code: 212,
    text: i18n.t('utils_areas_code_1050')
  },
  {
    code: 967,
    text: i18n.t('utils_areas_code_1051')
  },
  {
    code: 260,
    text: i18n.t('utils_areas_code_1052')
  },
  {
    code: 263,
    text: i18n.t('utils_areas_code_1053')
  }
];
